export default "__VITE_ASSET__27e63d55__"